import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import * as serviceWorker from './serviceWorker';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

// For Development Only
// localStorage.setItem('LG_APPLICATION', '{"access_token":"eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjI3YUViYk1oWTNjTmp4UzdnS01iN0JRaVR5ZCIsInNlciI6IlMwMDAyIiwiYXBwIjoiMXM0MWtneUFudjRkZnF4ZFJYekRWSUVmN1hKIiwia2V5IjoiMXM0M0NuM0tGNHJkSlFHMGwxeDFkaU5VNHhVIiwiZXh0cmEiOiJ7XCJjaXRpemVuX2lkXCI6XCJmb2N1c29uZVwiLFwiZmlyc3RfbmFtZVwiOm51bGwsXCJsYXN0X25hbWVcIjpudWxsLFwiZW1haWxcIjpudWxsfSIsImV4cCI6MTk2NTEyNTg2OCwiaWF0IjoxNjQ5NTQ5ODY4LCJpc3MiOiJTT05BUiBJTk5PVkFUSU9OIENPLiwgTFRELiJ9.qDCEUHHMfyLgspS_xm1ULaISWn1QjAs8P5XeF9-HJ0JjdLXFPX94wsj2CtBs7WV2eZZzFfjevUtBBgmK4_lqPLJh_HHECaedAFbl-Xd2JieLOADJ08EeNnBgAkDYJOe5lugq-UUbVOZI94i8KtAQaVpkkBoQEQiWI_lhKlRZ1_8"}');

ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    </QueryClientProvider>
    ,
    document.getElementById('root')
);

//registerServiceWorker();
serviceWorker.unregister();